import { Badge } from '@artosera/ui';
import type { EtatSalle } from '@artosera/shared';
import { useTranslation } from 'react-i18next';
import { useApercuMedia } from '../../api/medias.js';
import { VignetteOeuvre } from '../../composants/VignetteOeuvre.js';

export const texteSalle = (texte: { fr: string; en?: string }, langue: string) =>
  langue.startsWith('en') && texte.en?.trim() ? texte.en : texte.fr;
export const dateSalle = (date: string, langue: string, heure = false) =>
  new Intl.DateTimeFormat(langue, {
    dateStyle: 'long',
    ...(heure ? { timeStyle: 'short' as const } : {}),
  }).format(new Date(date));
export const dateSaisie = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const dateFinJour = (date: string) => new Date(`${date}T23:59:59`).toISOString();
export function EtatDeSalle({ etat }: { etat: EtatSalle }) {
  const { t } = useTranslation();
  return (
    <Badge tone={etat === 'active' ? 'available' : etat === 'revoquee' ? 'withdrawn' : 'neutral'}>
      {t(`regie:viewingRooms.etats.${etat}`)}
    </Badge>
  );
}
export function VignetteSalle({
  galerieSlug,
  mediaId,
  taille = 'sm',
}: {
  galerieSlug: string;
  mediaId: string | null;
  taille?: 'sm' | 'md' | 'lg';
}) {
  const apercu = useApercuMedia(galerieSlug, mediaId);
  return (
    <VignetteOeuvre url={apercu.data ?? null} taille={taille} data-ui="viewing-room-artwork" />
  );
}
